import { text } from 'ember-cli-page-object';
export default (scope = '[data-test-how-to-box]') => ({
  scope,
  init: text('.hds-code-block:eq(0)'),
  rubyConfig: text('.hds-code-block:eq(1)'),
  up: text('.hds-code-block:eq(2)')
});